export function CollaborationConditions() {
  const cannotCollaborate = [
    "Diagnosztizált inzulinrezisztenciád, cukorbetegséged, pajzsmirigybetegséged vagy más hormonális/endokrin zavarod van",
    "Gyógyszeres kezelés alatt állsz, amelyet az étrend befolyásolhat",
    "Fennáll nálad étkezési zavar (anorexia, bulimia, orthorexia)",
    "Terhesség vagy szoptatás alatt állsz",
    "Ételallergiá(i)d van(nak)",
    "18 év alatti vagy",
    "Még felépülőben vagy sérülésből, műtétből"
  ];

  const canCollaborate = [
    "Hosszútávon hajlandó vagy tenni az egészségedért",
    "Nem gyors megoldást vársz",
    "Készen állsz szeretni magad annyira, hogy tegyél magadért",
    "Nyitott vagy",
    "Rendszert akarsz vinni az életedbe",
    "Jelentőségteljesebb életre vágysz",
    "Egészséges, fittebb, energikusabb szeretnél lenni",
    "Kiegyensúlyozottságra vágysz"
  ];

  return (
    <section className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Cannot Collaborate Section */}
          <div className="space-y-8">
            <h2 className="text-4xl text-foreground">Nem tudunk még együttműködni, ha:</h2>
            <div className="space-y-4">
              {cannotCollaborate.map((condition, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-2 h-2 bg-primary rounded-full mr-4 mt-3 flex-shrink-0"></div>
                  <p className="text-base text-muted-foreground leading-relaxed">{condition}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Can Collaborate Section */}
          <div className="space-y-8">
            <h2 className="text-4xl text-foreground">Együtt tudunk működni, ha:</h2>
            <div className="space-y-4">
              {canCollaborate.map((condition, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-2 h-2 bg-primary rounded-full mr-4 mt-3 flex-shrink-0"></div>
                  <p className="text-base text-muted-foreground leading-relaxed">{condition}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}